import { render, staticRenderFns } from "./Kv-Img.vue?vue&type=template&id=80eb2e84&scoped=true"
import script from "./Kv-Img.vue?vue&type=script&lang=js"
export * from "./Kv-Img.vue?vue&type=script&lang=js"
import style0 from "./Kv-Img.vue?vue&type=style&index=0&id=80eb2e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80eb2e84",
  null
  
)

export default component.exports